import React from 'react';

const DoubleArrowSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M15 4l-.614.614L18.736 9H4v1h16V9l-5-5zM9 20l.614-.614L5.264 15H20v-1H4v1l5 5z"
            fillRule="evenodd"
        />
    </svg>
);

DoubleArrowSvg.displayName = 'DoubleArrowSvg';
export default DoubleArrowSvg;
